import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://placeholder.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "placeholder-anon-key";

if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.warn("Supabase configuration is missing — running in offline mode.");
}

function readOrCreate(key: string): string {
  try {
    let id = localStorage.getItem(key);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(key, id);
    }
    return id;
  } catch {
    return "";
  }
}

// Device identifiers are sent as request headers so the database can restrict
// every anonymous row to the device that actually created it.
const deviceHeaders: Record<string, string> = {
  "x-device-id": readOrCreate("device_id"),
  "x-allergy-device-id": readOrCreate("allergy_device_id"),
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: { headers: deviceHeaders },
});
